


export function generateExportContent(
  data, 
  format, // "xls" | "doc",
  colors, 
) {
  const hs = `background:${colors.primary};color:${colors.headerText};`;
  const fmt = (n) => n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  if (format === "xls") {
    const rows = data.lines
      .map(
        (l) =>
          `<tr><td>${l.chargeCode || ""}</td><td>${l.description}</td><td>${l.currency}</td><td>${l.roe}</td><td>${l.quantity}</td><td>${fmt(l.unit_price)}</td><td>${fmt(l.total_amount)}</td></tr>`
      )
      .join("");
    return `<html><head><meta charset="UTF-8"></head><body>
      <table border="1">
        <tr><th colspan="7" style="${hs}font-size:18px;">${data.invoiceType || "BILL"}</th></tr>
        <tr><td><b>Bill Number #</b></td><td>${data.bill_no}</td><td><b>Date</b></td><td>${data.bill_date}</td><td><b>Due</b></td><td colspan="2">${data.due_date}</td></tr>
        <tr><td><b>Vendor Nmae</b></td><td colspan="6">${data.vendor_name}</td></tr>
        <tr><th style="${hs}">Charge Code</th><th style="${hs}">Description</th><th style="${hs}">Curr</th><th style="${hs}">ROE</th><th style="${hs}">Qty</th><th style="${hs}">Rate</th><th style="${hs}">Amount</th></tr>
        ${rows}
        <tr><td colspan="6" style="text-align:right;"><b>TOTAL</b></td><td><b>$${fmt(data.total_amount)}</b></td></tr>
      </table></body></html>`;
  }

  return `<html><head><meta charset="UTF-8"><title>Invoice</title></head>
    <body style="font-family:Arial,sans-serif;color:${colors.valueColor};">
      <h1 style="color:${colors.primary};text-align:center;">${data.invoiceType || "BILL"}</h1>
      <hr style="border:2px solid ${colors.primary};">
      <table style="width:100%;"><tr><td><b>Bill Number #:</b> ${data.bill_no}</td><td><b>Date:</b> ${data.bill_date}</td><td><b>Due:</b> ${data.due_date}</td></tr></table>
      <h2 style="${hs}padding:8px;">BILL TO</h2>
      <p><b>${data.customer.name}</b><br>${data.customer.address || ""}<br>${data.customer.phone || ""}</p>
      <h2 style="${hs}padding:8px;">CHARGES</h2>
      <table style="width:100%;border-collapse:collapse;" border="1">
        <tr><th>Code</th><th>Description</th><th>Curr</th><th>Qty</th><th>Rate</th><th>Amount</th></tr>
        ${data.lines.map((l) => `<tr><td>${l.chargeCode || ""}</td><td>${l.description}</td><td>${l.currency}</td><td>${l.quantity}</td><td>${fmt(l.unit_price)}</td><td>${fmt(l.total_amount)}</td></tr>`).join("")}
      </table>
      <p style="text-align:right;font-size:18px;"><b>Total: $${fmt(data.total_amount)}</b></p>
    </body></html>`;
}



